import { ISoundsModel } from './interfaces';

export const soundsSelectors = {
    getStudioSoundsMuted: (state: ISoundsModel) => state.studioSoundsMuted,

    getGameSoundsMuted: (state: ISoundsModel) => state.gameSoundsMuted,

    getBackgroundMusicMuted: (state: ISoundsModel) => state.backgroundMusicMuted,
};
